/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for article with quantity data.
 * @export
 * @interface APIArticleWithQuantityRequest
 */
export interface APIArticleWithQuantityRequest {
    /**
     * 
     * @type {string}
     * @memberof APIArticleWithQuantityRequest
     */
    article: string;
    /**
     * 
     * @type {number}
     * @memberof APIArticleWithQuantityRequest
     */
    quantity?: number;
}

/**
 * Check if a given object implements the APIArticleWithQuantityRequest interface.
 */
export function instanceOfAPIArticleWithQuantityRequest(value: object): value is APIArticleWithQuantityRequest {
    if (!('article' in value) || value['article'] === undefined) return false;
    return true;
}

export function APIArticleWithQuantityRequestFromJSON(json: any): APIArticleWithQuantityRequest {
    return APIArticleWithQuantityRequestFromJSONTyped(json, false);
}

export function APIArticleWithQuantityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleWithQuantityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'article': json['article'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function APIArticleWithQuantityRequestToJSON(value?: APIArticleWithQuantityRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'article': value['article'],
        'quantity': value['quantity'],
    };
}

